<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img class="logo" src="../assets/images/app-logo.svg"></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>
<ion-content full>
  <ion-grid class="box confirm-register">
    <ion-row class="content-padding-vertical">
      <ion-col>
        <app-loading-sti *ngIf="loading"></app-loading-sti>
        <div *ngIf="!loading" class="ion-text-center">
          <header class="confirm-register__header">
            <ion-icon [src]="iconSrc"></ion-icon>
            <h1>
              {{ (activated ? 'CONFIRM_REGISTER.HEADER_ACCTIVATED' :
              'CONFIRM_REGISTER.HEADER_NOT_ACCTIVATED') | translate }}
            </h1>
          </header>
          <main>
            <p>
              {{ (activated ? 'CONFIRM_REGISTER.ACCOUNT_ACCTIVATED' :
              'CONFIRM_REGISTER.ACCOUNT_NOT_ACCTIVATED') | translate }}
            </p>
            <ng-container *ngIf="activated; else tryAgain">
              <ion-button
                class="confirm-register__button"
                size="large"
                expand="block"
                routerLink="/auth"
              >
                {{ 'CONFIRM_REGISTER.LOGIN_BUTTON' | translate }}
              </ion-button>
            </ng-container>
            <ng-template #tryAgain>
              <ion-button
                class="confirm-register__button"
                size="large"
                routerLink="/auth/register"
                expand="block"
              >
                {{ 'CONFIRM_REGISTER.TRY_AGAIN' | translate }}
              </ion-button>
            </ng-template>
          </main>
        </div>
      </ion-col>
    </ion-row>
    <ion-row
      *ngIf="!activated"
      class="content-padding-vertical confirm-register__support-box"
    >
      <ion-col class="ion-text-center">
        <footer class="confirm-register__footer">
          <h2>{{ 'CONFIRM_REGISTER.HAVING_TROUBLE' | translate }}</h2>
          <p>{{ 'CONFIRM_REGISTER.CONTACT_US' | translate }}</p>
          <div class="confirm-register__support-email">
            <a href="mailto:kontakt@space-tech.it">
              <ion-icon src="../../../../assets/icons/envelope.svg"></ion-icon>
              <span> kontakt&#64;space-tech.it </span></a
            >
          </div>
        </footer>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
